import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

const IMAGES: Record<string, string> = {
  "luxury-vinyl-tile": "https://assets.cdn.filesafe.space/D8zHHsXQdNqiD1R03R0i/media/6a886fbb67ecc8731d47cf7b.webp",
  "hardwood-flooring": "https://assets.cdn.filesafe.space/D8zHHsXQdNqiD1R03R0i/media/6a886f60b647fb6eca0f8557.webp",
  "laminate-flooring": "https://assets.cdn.filesafe.space/D8zHHsXQdNqiD1R03R0i/media/6a886dc6ad59e6cfed113597.webp",
  "floor-refinishing": "https://assets.cdn.filesafe.space/D8zHHsXQdNqiD1R03R0i/media/6a886ef167ecc8731d46fd2c.webp",
  "luxury-vinyl-plank": "https://assets.cdn.filesafe.space/D8zHHsXQdNqiD1R03R0i/media/6a886e82cdd4b797a312f34c.webp",
};

export function ServicesGrid() {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {SERVICES.map((s) => (
        <Link
          key={s.slug}
          to={`/services/${s.slug}`}
          className="group relative overflow-hidden rounded-lg border border-border bg-surface shadow-soft hover:shadow-elev transition-all"
        >
          <div className="aspect-[4/3] overflow-hidden">
            <img
              src={IMAGES[s.slug]}
              alt={`${s.name} installation project by VRP Flooring`}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
              width={1280}
              height={960}
            />
          </div>
          <div className="p-6">
            <div className="flex items-start justify-between gap-3 mb-2">
              <h3 className="font-display text-xl font-semibold">{s.name}</h3>
              <ArrowUpRight className="h-5 w-5 text-accent shrink-0 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">{s.short}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}

export { IMAGES as SERVICE_IMAGES };
